import React, { useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { themes } from 'src/themes'

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useMemo(() => themes.dark, [])

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}
